import { ExclamationCircleOutlined } from '@ant-design/icons'
import { Col, Modal, Row } from 'antd'
import { PropsWithChildren, FC } from 'react'

import Button from '~/core/Button'
import Text from '~/core/Text'
import getColor from '~/lib/getColor'

interface BusinessAccountJoinTermsModalPropsType {
    isOpen: boolean
    onClose: () => void
}

export const BusinessAccountJoinTermsModal: FC<
    PropsWithChildren<BusinessAccountJoinTermsModalPropsType>
> = ({ isOpen, onClose }) => {
    return (
        <Modal
            onCancel={onClose}
            visible={isOpen}
            footer={[
                <Button key={'close button'} onClick={onClose}>
                    Close
                </Button>,
            ]}
            closable={false}
        >
            <Text />
            <Row justify="center">
                <Col span={2}>
                    <ExclamationCircleOutlined
                        height={'21px'}
                        width={'21px'}
                        style={{
                            color: getColor('info6'),
                            fontSize: '21px',
                        }}
                    />
                </Col>
                <Col span={22}>
                    <Text
                        element={'h2'}
                        fontWeight={400}
                        fontSize={'16px'}
                        lineHeight={'24px'}
                        style={{ marginTop: '0' }}
                    >
                        Joining your organization on Fictiv
                    </Text>
                    <Text style={{ marginBottom: '12px' }} element={'p'}>
                        By joining your organization’s Business Account, you
                        represent you have the authority to act and transact,
                        and modify account settings, on behalf of the employer
                        associated with your account.
                    </Text>
                    <Text style={{ marginBottom: '12px' }} element={'p'}>
                        Note: Upon joining, you will not lose access to any
                        existing quotes and orders.
                    </Text>
                </Col>
            </Row>
        </Modal>
    )
}

export default BusinessAccountJoinTermsModal
